import TranslationContext from './translations/translationContext';

import useStorefrontBaseRoutes from '../hooks/useStorefrontBaseRoutes';
import useStorefrontConfig from '../hooks/useStorefrontConfig';
import useTranslations from '../hooks/useTranslations';
import useVendor from '../hooks/useVendor';
import StorefrontRoutesContext from './offers/storefrontRoutesContextContext';
import { getBnclCampaignId, getBnclCampaignIsPreview } from '../helpers/utils';
import CampaignPage from '../pages/campaignPage';
import BnclCampaignPage from '../pages/bnclCampaignPage';
import { JSX } from 'preact';

const App = (): JSX.Element => {
    const bnclCampaignId = getBnclCampaignId();
    const bnclIsPreview = getBnclCampaignIsPreview();
    const vendor = useVendor();
    const storefrontConfig = useStorefrontConfig();
    const translationsObject = useTranslations();
    const routes = useStorefrontBaseRoutes(storefrontConfig);
    if (storefrontConfig.loading || translationsObject.loading || routes.loading) {
        return <div id='app' />;
    }

    let vendorShorthand = 'alb';
    if (vendor.includes('photobox')) {
        vendorShorthand = 'pbx';
    } else if (vendor.includes('hofmann')) {
        vendorShorthand = 'hfm';
    }
    document.documentElement.classList.add(`arc3-${vendorShorthand}`);

    const headElement = document.head || document.querySelector('head');
    let favicon = headElement.querySelector('link[rel="shortcut icon"]');
    if (!favicon) {
        favicon = document.createElement('link');
        favicon.setAttribute('rel', 'shortcut icon');
        headElement.appendChild(favicon);
    }
    favicon.setAttribute(
        'href',
        `${storefrontConfig.data?.routes.Main}/application-icons/favicon-${vendorShorthand}.ico`
    );

    return (
        <div id='app'>
            <TranslationContext.Provider
                value={translationsObject.data}
                children={
                    <StorefrontRoutesContext.Provider
                        value={routes.data}
                        children={
                            bnclCampaignId ? (
                                <BnclCampaignPage
                                    storefrontConfig={storefrontConfig}
                                    bnclCampaignId={bnclCampaignId}
                                    isPreview={bnclIsPreview}
                                />
                            ) : (
                                <CampaignPage storefrontConfig={storefrontConfig} />
                            )
                        }
                    />
                }
            />
        </div>
    );
};

export default App;
